export default __webpack_public_path__ + "static/media/ico-foot-twitter.3aad5486.svg";